export default {
  tabs: [
    {
      /*
        评估app：
          首页-车源盘点
          点击车源盘点任务push消息
        销售app：
          首页-车源盘点；
          消息-车源盘点-车源盘点消息页；
          点击车源盘点任务push消息；
      */
      name: 'CarInventoryList',
      path: '/carInventory/list',
      component: () => import('./src/CarInventoryList.vue'),
      meta: {
        title: '盘点车源列表',
        keepAlive: true
      },
    },
    {
      name: 'CarInventoryInstructions',
      path: '/carInventory/instructions',
      component: () => import('./src/CarInventoryInstructions.vue'),
      meta: {
        title: '操作说明',
      },
    },
    {
      name: 'CarInventoryTip',
      path: '/carInventory/tip',
      component: () => import('./src/CarInventoryTip.vue'),
      meta: {
        title: '车源盘点',
      },
    },
  ],
}
